import { ActionContext } from 'vuex';

export interface Toast {
  id: number;
  msg: string;
  mode: 'error' | 'success' | 'info' | 'warning';
  duration: number;
  action: {
    label: string;
    callback: () => void;
  };
}

interface State {
  toasts: Toast[];
}

const state: State = {
  toasts: []
};

const getters = {};

const mutations = {
  addToast(state: State, toastData: Toast): void {
    state.toasts.push(toastData);

    if (state.toasts.length > 3) {
      state.toasts.shift();
    }
  },
  removeToast(state: State, toastId: number): void {
    state.toasts = state.toasts.filter(toast => toast.id !== toastId);
  },
  updateToast(state: State, toast: Toast): void {
    const toastIndex = state.toasts.findIndex(t => t.id === toast.id);
    if (toastIndex !== -1) {
      state.toasts[toastIndex] = toast;
    }
  }
};

const actions = {
  triggerToast(context: ActionContext<State, any>, toast: Toast): number {
    const { msg, duration = 6000, mode, action } = toast;
    const id = new Date().getTime();
    context.commit('addToast', {
      msg,
      duration,
      mode,
      action,
      id
    } as Toast);
    return id;
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
